<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          :row-class-name="rowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="company_name"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="lab_order_id"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="订单时间">
          </el-table-column>
          <el-table-column
            prop="total"
            label="总价">
          </el-table-column>
          <el-table-column
            prop="days"
            label="完成期限">
          </el-table-column>
          <el-table-column
            prop="amount"
            label="数量">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini" class="detail-btn" @click="handleSeeDetail(scope.row)"><span>详情</span></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
import { getStore } from 'common/js/mUtils.js'
export default {
  data () {
    return {
      empty: '没有委外完成委托单',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      user_type: 0,
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.user_type = getStore('user_type')
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    rowClass({row}){
      if (row.type == 1) {
        return 'row-color'
      }
    },
    // 获取未完成的订单列表
    initData () {
      let that = this
      this.$api.seeOtherOrder({
        page_num: (that.page-1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.detail.length > 0) {
          that.tableData = res.data.detail
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.detail
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      this.initData()
    },
    handleSeeDetail (row) { // 点击详情
      this.$router.push({
        path: '/orderDetail',
        query: { lab_order_id: row.lab_order_id, type: row.type }
      })
    },
  },
  watch: {
  },
  components: {
  }
}
/* 未创建委托单可以查看详情 还有 如果没有发样的 还要显示 发样按钮  但是要是查看详情的话 就要如果还没有要发样的话 就需要修改 仪器还有 给订单添加新的仪器 如果已经发过样的话 就不能把订单给你在修改 */
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
</style>
